import styled from 'styled-components';

const colors = require('common/lib/colors/colors.less');
import fontFamily from '../data/font-family';

/* eslint-disable indent */
const CardLabel = styled.span.attrs({
  title: ({ children }) => children,
})`
  border-radius: ${({ children }) => (children ? '3px' : '100px')};
  background-color: ${({ color }) => {
    if (colors.hasOwnProperty(color)) {
      return colors[color];
    }

    return color;
  }};
  color: ${({ fontColor }) => fontColor || colors.white};
  display: inline-block;
  font-family: ${fontFamily};
  font-size: 12px;
  font-weight: 600;
  height: ${({ children }) => (children ? 16 : 8)}px;
  position: relative;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  vertical-align: top;

  &::before {
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    top: 0;
    width: ${({ children }) => (children ? '16px' : '100%')};
    ${({ pattern }) => {
      // tslint:disable:max-line-length
      switch (pattern) {
        case 'checkered':
          return `
            background-image: linear-gradient(135deg, rgba(255, 255, 255, 0.5) 25%, transparent 25%),
                              linear-gradient(225deg, rgba(255, 255, 255, 0.5) 25%, transparent 25%),
                              linear-gradient(315deg, rgba(255, 255, 255, 0.5) 25%, transparent 25%),
                              linear-gradient(45deg, rgba(255, 255, 255, 0.5) 25%, transparent 25%);
            background-size: 12px 12px;
          `;

        case 'slant-right':
          return `
            background-image: linear-gradient(to bottom left, rgba(255, 255, 255, 0.5) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.5) 75%, transparent 75%, transparent);
            background-size: 16px 16px;
          `;

        case 'slant-left':
          return `
            background-image: linear-gradient(to bottom right, rgba(255, 255, 255, 0.5) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.5) 75%, transparent 75%, transparent);
            background-size: 16px 16px;
          `;

        case 'striped':
          return `
            background-image: linear-gradient(to right, rgba(255, 255, 255, 0.5) 50%, transparent 50%, transparent);
            background-size: 8px 8px;
          `;

        default:
          return '';
        // tslint:enable:max-line-length
      }
    }};
  }

  ${({ children, pattern }) => {
    if (children) {
      return `
        box-sizing: border-box;
        line-height: 16px;
        max-width: 100%;
        min-width: 56px;
        overflow: hidden;
        padding: 0 8px 0 ${pattern ? 24 : 8}px;
        text-overflow: ellipsis;
        white-space: nowrap;
      `;
    } else {
      return 'width: 40px;';
    }
  }};
`;

export default CardLabel;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/CardLabel.js